import { CHIPS_INITIAL_DATA } from "./CustomChip.constants";
import { ChipsContainer, StyledChip } from "./CustomChip.styles";

const CustomChips = () => {
  return (
    <ChipsContainer>
      {CHIPS_INITIAL_DATA.map((chip) => (
        <StyledChip key={chip.label} label={chip.label} noHover />
      ))}
    </ChipsContainer>
  );
};

export default CustomChips;
